const navigationMixin = (Base = null) => class extends Base {

	injectNavigation(navigation) {
		this.navigation = navigation;
	}

};

export default navigationMixin;
